export default "__VITE_ASSET__DWVRwiha__"